/* eslint react/require-default-props: 0 */
/* eslint arrow-body-style: 0 */
import cs from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pageResolver from './page-resolver';
import paginationHandler from './pagination-handler';
import { SizePerPageDropdownWithAdapter } from './size-per-page-dropdown-adapter';
import { PaginationListWithAdapter } from './pagination-list-adapter';
import { PaginationTotalWithAdapter } from './pagination-total-adapter';
import Const from './const';

class Pagination extends pageResolver(Component) {
    render() {
        const {
            tableId,
            currPage,
            pageStartIndex = Const.PAGE_START_INDEX,
            showTotal = Const.SHOW_TOTAL,
            dataSize,
            pageListRenderer = null,
            pageButtonRenderer = null,
            paginationTotalRenderer = Const.PAGINATION_TOTAL,
            hidePageListOnlyOnePage = Const.HIDE_PAGE_LIST_ONLY_ONE_PAGE,
            totalPages,
            lastPage,
            onPageChange,
            sizePerPageList = Const.SIZE_PER_PAGE_LIST,
            currSizePerPage,
            hideSizePerPage = Const.HIDE_SIZE_PER_PAGE,
            sizePerPageRenderer = null,
            sizePerPageOptionRenderer = null,
            onSizePerPageChange,
            bootstrap4 = false,
            tooltipTargetId,
            ...rest
        } = this.props;

        const pages = this.calculatePageStatus(
            this.calculatePages(totalPages, lastPage),
            lastPage
        );
        const pageListClass = cs('react-bootstrap-table-pagination-list', {
            'react-bootstrap-table-pagination-list-hidden':
                hidePageListOnlyOnePage && totalPages === 1,
        });

        return (
            <div className="row react-bootstrap-table-pagination">
                <SizePerPageDropdownWithAdapter
                    bootstrap4={bootstrap4}
                    tableId={tableId}
                    tooltipTargetId={tooltipTargetId}
                    sizePerPageList={sizePerPageList}
                    currSizePerPage={currSizePerPage}
                    hideSizePerPage={hideSizePerPage}
                    sizePerPageRenderer={sizePerPageRenderer}
                    sizePerPageOptionRenderer={sizePerPageOptionRenderer}
                    onSizePerPageChange={onSizePerPageChange}
                    className={'dropdwon-margin'}
                />
                {showTotal ? (
                    <PaginationTotalWithAdapter
                        currPage={currPage}
                        currSizePerPage={currSizePerPage}
                        pageStartIndex={pageStartIndex}
                        dataSize={dataSize}
                        paginationTotalRenderer={paginationTotalRenderer}
                    />
                ) : null}
                {pageListRenderer ? (
                    pageListRenderer({
                        pages,
                        onPageChange,
                    })
                ) : (
                    <div className={pageListClass}>
                        <PaginationListWithAdapter
                            {...rest}
                            currPage={currPage}
                            currSizePerPage={currSizePerPage}
                            pageStartIndex={pageStartIndex}
                            lastPage={lastPage}
                            totalPages={totalPages}
                            pageButtonRenderer={pageButtonRenderer}
                            onPageChange={onPageChange}
                            tooltipTargetId={tooltipTargetId}
                        />
                    </div>
                )}
            </div>
        );
    }
}

Pagination.propTypes = {
    dataSize: PropTypes.number.isRequired,
    sizePerPageList: PropTypes.array.isRequired,
    currPage: PropTypes.number.isRequired,
    currSizePerPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onSizePerPageChange: PropTypes.func.isRequired,
    disablePageTitle: PropTypes.bool,
    pageStartIndex: PropTypes.number,
    paginationSize: PropTypes.number,
    showTotal: PropTypes.bool,
    pageListRenderer: PropTypes.func,
    pageButtonRenderer: PropTypes.func,
    sizePerPageRenderer: PropTypes.func,
    paginationTotalRenderer: PropTypes.func,
    sizePerPageOptionRenderer: PropTypes.func,
    firstPageText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    prePageText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    nextPageText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    lastPageText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    nextPageTitle: PropTypes.string,
    prePageTitle: PropTypes.string,
    firstPageTitle: PropTypes.string,
    lastPageTitle: PropTypes.string,
    withFirstAndLast: PropTypes.bool,
    alwaysShowAllBtns: PropTypes.bool,
    hideSizePerPage: PropTypes.bool,
    hidePageListOnlyOnePage: PropTypes.bool,
    bootstrap4: PropTypes.bool,
    tooltipTargetId: PropTypes.string,
};

export default paginationHandler(Pagination);
